import type { AuthenticatedUser } from '../../../../auth/types/AuthenticatedUser'
import { initialState as initialStateActiviteiten } from '../../../activiteiten/services/searchActiviteiten'
import { initialState as initialStateAssignedBijlagen } from '../../../bijlagen/services/searchAssignedBijlagen'
import { initialState as initialStateProjecten } from '../../../projecten/services/searchProjecten'
import type { DashboardNavigation } from '../../types/DashboardNavigation'
import type { FetchWerklijstenFilters } from '../../types/FetchWerklijsten'
import type { Werklijst } from '../../types/Werklijst'

export {
  pickWerklijstFilters,
  generateActiesQuery,
  generateAssignedBijlagenQuery,
  generateActiviteitenQuery,
}

const pickWerklijstFilters = ({
  gebied,
  labels,
  myList,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
}: FetchWerklijstenFilters) => ({
  gebied,
  labels,
  myList,
  fromGeplandeUitvoeringsdatum,
  toGeplandeUitvoeringsdatum,
})

const generateActiesQuery = ({
  werklijst,
  filters,
  user,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  user: AuthenticatedUser
}): DashboardNavigation => {
  const { code, label } = werklijst
  const actiehouder = user.deelnemer
    ? { group: '', label: user.organisatie }
    : filters.organisatie

  return {
    url: '/aansluiting/projecten',
    query: {
      filters: {
        ...initialStateProjecten.query.filters,
        ...pickWerklijstFilters(filters),
        actie: { code, label },
        actiehouder,
      },
      page: initialStateProjecten.query.page,
      sort: initialStateProjecten.query.sort,
    },
  }
}

const generateAssignedBijlagenQuery = ({
  werklijst,
  filters,
  kpiColor,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  kpiColor?: string
}): DashboardNavigation => {
  const { label } = werklijst

  return {
    url: '/aansluiting/bijlagen',
    query: {
      filters: {
        ...initialStateAssignedBijlagen.query.filters,
        ...pickWerklijstFilters(filters),
        documentsoort: [label],
        assignedTo: filters.organisatie ? [filters.organisatie] : [],
        kpi: kpiColor ?? '',
      },
      page: initialStateAssignedBijlagen.query.page,
      sort: initialStateAssignedBijlagen.query.sort,
    },
  }
}

const generateActiviteitenQuery = ({
  werklijst,
  filters,
  kpiColor,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  kpiColor?: string
}): DashboardNavigation => {
  const { code, label } = werklijst

  return {
    url: '/aansluiting/activiteiten',
    query: {
      filters: {
        ...initialStateActiviteiten.query.filters,
        ...pickWerklijstFilters(filters),
        type: [{ code, label }],
        assignedTo: filters.organisatie ? [filters.organisatie] : [],
        kpi: kpiColor ?? '',
      },
      page: initialStateActiviteiten.query.page,
      sort: initialStateActiviteiten.query.sort,
    },
  }
}
